<nav class="navbar custom-navbar" [class.top-nav-collapse]="isCollapsed">
  <div class="nav-container">
    <a class="nav-logo" href="">
      <img src="assets/images/xchange.png" alt="logo">
    </a>

    <div class="nav-menu" [class.show]="menuOpen" id="navMenu">
      <ul class="nav-links">
        <li><a routerLink="/" (click)="closeMenu()">Home</a></li>
        <li><a routerLink="/intro" (click)="closeMenu()">Intro</a></li>
        <li><a routerLink="/howItWorks" (click)="closeMenu()">How it Works</a></li>
        <li><a routerLink="/features" (click)="closeMenu()">Features</a></li>
        <li *ngIf="!user"><a routerLink="/contact-us" (click)="closeMenu()">Contact Us</a></li>
        <li *ngIf="!user"><a routerLink="/faqs" (click)="closeMenu()">FAQ's</a></li>
      </ul>

      <ul class="nav-links nav-auth-mobile">
        <li *ngIf="extra" class="nav-btns">
          <a routerLink="/account/login" class="btn" (click)="closeMenu()">Login</a>
          <a routerLink="/account/register-email" class="btn sign-up" (click)="closeMenu()">Signup</a>
        </li>

        <li *ngIf="!extra" class="nav-btns">
          <a (click)="dashboard(); closeMenu()" class="btn">Dashboard</a>
          <a (click)="logout(); closeMenu()" class="btn sign-up">Logout</a>
        </li>
      </ul>
    </div>

    <div class="nav-auth-desktop">
      <ul class="nav-links">
        <li *ngIf="extra" class="nav-btns">
          <a routerLink="/account/login" class="btn">Login</a>
          <a routerLink="/account/register-email" class="btn sign-up">Signup</a>
        </li>

        <li *ngIf="!extra" class="nav-btns">
          <a (click)="dashboard()" class="btn">Dashboard</a>
          <a (click)="logout()" class="btn sign-up">Logout</a>
        </li>
      </ul>
    </div>

    <button class="nav-toggle" type="button" aria-label="Toggle navigation"
      [attr.aria-expanded]="menuOpen" (click)="toggleMenu()">
      ☰
    </button>
  </div>
</nav>
